import { UserModifyMutationDocument as __graphqlDocument0 } from 'store/client/documents/UserModifyMutationDocument'; 

export const userModify = __graphqlDocument0











































































































































































































































































;
